"use client";

import { useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { PlayCircle, Sparkles } from "lucide-react";

const DemoCTASection = () => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  return (
    <section className="py-20 px-6">
      <div className="container mx-auto">
        <div className="relative overflow-hidden rounded-3xl border-2 border-border bg-card p-10 md:p-14">
          <div className="absolute -top-20 -right-20 h-56 w-56 rounded-full bg-secondary/20 blur-3xl" />
          <div className="absolute -bottom-20 -left-20 h-56 w-56 rounded-full bg-primary/20 blur-3xl" />

          <div className="relative z-10 flex flex-col md:flex-row items-center justify-between gap-8">
            <div className="flex-1 text-center md:text-left">
              <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary/20 text-foreground text-xs font-heading font-bold mb-4">
                <Sparkles className="w-3.5 h-3.5" aria-hidden="true" />
                {t("demo.badge")}
              </span>
              <h2 className="font-heading font-bold text-3xl md:text-4xl mb-3">
                <Trans
                  i18nKey="demo.title"
                  components={{ gradient: <span className="text-gradient" /> }}
                />
              </h2>
              <p className="text-muted-foreground text-lg max-w-xl">
                {t("demo.subtitle")}
              </p>
            </div>

            <Button
              size="lg"
              className="group shrink-0 bg-primary text-primary-foreground hover:brightness-105 border-2 border-primary-foreground/10 shadow-lg shadow-primary/25"
              onClick={() => setOpen(true)}
            >
              <PlayCircle className="!w-5 !h-5" aria-hidden="true" />
              {t("demo.watch")}
            </Button>
          </div>
        </div>
      </div>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-4xl p-0 overflow-hidden border-2 border-border bg-card">
          <DialogTitle className="sr-only">{t("demo.dialogTitle")}</DialogTitle>
          <div className="aspect-video w-full bg-black">
            {open && (
              <video
                className="w-full h-full"
                src="https://cdn.coverr.co/videos/coverr-people-working-together-2598/1080p.mp4"
                controls
                autoPlay
                playsInline
              />
            )}
          </div>
        </DialogContent>
      </Dialog>
    </section>
  );
};

export default DemoCTASection;
